export default __webpack_public_path__ + "static/media/be8a4f5ed9dfb474.38ebfa137354c3c1f259626264dbcb00.svg";